import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { GameMetaItem } from '../api/gamesMetaApi';

interface GameMetaState {
  items: Record<string, { shortDesc: string; rtp: number }>;
}

const initialState: GameMetaState = {
  items: {},
};

const gameMetaSlice = createSlice({
  name: 'gameMeta',
  initialState,
  reducers: {
    fetchRequest(_state) {},
    fetchSuccess(state, action: PayloadAction<GameMetaItem[]>) {
      action.payload.forEach(({ id, short_desc, rtp }) => {
        state.items[id] = { shortDesc: short_desc, rtp };
      });
    },
  },
});

export const gameMetaActions = gameMetaSlice.actions;
export const gameMetaReducer = gameMetaSlice.reducer;
